<template>
	<Tab
		class="athlete-tags"
		:tabs="tabs"
		:icon-size="`lg`"
		:use-shadow-watcher="true"
		:active-tab="activeTab"
		@tab-change="$emit('tab-change', $event)"
	>
		<template #tab-details-event-tags>
			<ListView
				:items="eventClips"
				:empty-msg="emptyMsg.message"
				:swipable="isMobileWebApp"
				:swipe-left-options="{ icon: 'network-communication', action: handleShare }"
				:swipe-right-options="isViewModeOrFullPageMode ? {} : { icon: 'bin', action: handleDelete }"
			>
				<template #no-results>
					<NoResults
						:title="emptyMsg.title"
						:description="emptyMsg.description"
					/>
				</template>
				<template #item-row="{ item }">
					<ClipListTile
						:clip="item"
						:event-id="event.id"
						:is-playing="playingClipId === item.id"
						@play="handlePlay"
						@edit="handleEdit"
						@share="handleShare"
						@delete="handleDelete"
					/>
				</template>
			</ListView>
		</template>
		<template #tab-details-athlete-tags>
			<AthletesClipList
				class="athletes-clip-list-wrapper"
				:clips="athleteClips"
				:playing-clip-id="playingClipId"
				:empty-msg="emptyMsg"
				@play="handlePlay"
				@edit="handleEdit"
				@share="handleShare"
				@delete="handleDelete"
			/>
		</template>
	</Tab>
</template>

<script>
import Tab from '@components/tab/Tab';
import ListView from '@components/lists/ListView';
import ClipListTile from '@components/clip-list/ClipListTile';
import AthletesClipList from '@components/clip-list/AthletesClipList';
import { TAB_ATHLETE_TAGS, TAB_EVENT_TAGS } from '@videotools/js/constants/athletes';
import NoResults from '@videotools/js/analysis/components/TagList/NoResults';
import { mapGetters } from 'vuex';

export default {
	name:       'RaceSportClipList',
	components: { NoResults, AthletesClipList, ClipListTile, ListView, Tab },
	props:      {
		activeTab: {
			default: null,
		},
		eventClips: {
			type:    Array,
			default: () => [],
		},
		athleteClips: {
			type:    Array,
			default: () => [],
		},
		sportName: {
			type:    String,
			default: '',
		},
		event: {
			type:     Object,
			required: true,
		},
		emptyMsg: {
			type: [String, Object],
		},
		itemPlayingId: {
			type: [Number, String],
		},
		playingClipId: {
			type: Number,
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp:           'app/isMobileWebApp',
			isViewModeOrFullPageMode: 'app/isViewModeOrFullPageMode',
		}),
		tabs() {
			return [
				{
					key:   TAB_EVENT_TAGS,
					label: this.transChoiceUcFirst('commons.event', 1),
					icon:  'calendar',
				},
				{
					key:   TAB_ATHLETE_TAGS,
					label: this.transChoiceUcFirst('commons.athlete', 1),
					icon:  'users-wm',
				},
			];
		},
	},
	methods: {
		handleShare(clip) {
			this.$emit('share', clip);
		},
		handleDelete(clip) {
			this.$emit('delete', clip);
		},
		handlePlay(clip) {
			this.$emit('play', clip);
		},
		handleEdit(clip) {
			this.$emit('edit', clip);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.athlete-tags::v-deep {
	.tabs li {
		padding: 16px;
		background: var(--color-grey-950);

		&.is-active {
			background: var(--color-grey-900);
			border-bottom: none;
		}
	}

	.tab-content {
		background: var(--color-grey-900);
	}
}
</style>
